import React, { lazy, Suspense } from "react";
import LoadingComponent from "./loading-component";
import ChatList from "../../../../components/chat-list";

const ChatNewFallback = lazy(() =>
  import("../../../../components/chat-new-fallback")
);
const ChatListHasntAccepted = lazy(() =>
  import("../../../../components/chat-not-accepted")
);

const ChatListRequest = lazy(() =>
  import("../../../../components/chat-list-request")
);

const ChatPageSwitch = (props) => {
  const {
    loading,
    newChat,
    hasAccepted,
    isChatRequest,
    messages,
    name,
    surname,
    firstMessage,
    profilePicture,
  } = props;

  if (loading) {
    return <LoadingComponent />;
  }

  if (newChat) {
    return (
      <Suspense fallback={<LoadingComponent />}>
        <ChatNewFallback name={name} />
      </Suspense>
    );
  }

  if (isChatRequest) {
    return (
      <>
        <Suspense fallback={<LoadingComponent />}>
          {isChatRequest && (
            <ChatListRequest
              name={name}
              message={firstMessage}
              surname={surname}
              profilePicture={profilePicture}
            />
          )}
        </Suspense>
        <ChatList messages={[firstMessage]} hasAccepted={hasAccepted} />;
      </>
    );
  }

  if (!hasAccepted) {
    return (
      <Suspense fallback={<LoadingComponent />}>
        <ChatListHasntAccepted name={name} message={firstMessage} />
      </Suspense>
    );
  }

  return <ChatList name={name} messages={messages} />;
};

export default ChatPageSwitch;
